<template>
  <app-page-subsection
    id="trainer"
    class="@container"
    :title="{ tag: 'h3', text: title }"
  >
    <figure class="flex flex-col items-start gap-8 @xl:flex-row">
      <app-user-avatar
        :avatar-url="teacher.avatar_url"
        class="!rounded-xl"
        :name="teacher.full_name"
        :size="255"
      />

      <figcaption>
        <section>
          <header class="mb-4">
            <h3 class="mb-1 text-xl font-bold">
              {{ teacher.full_name }}
            </h3>

            <p class="flex flex-wrap items-center gap-2 text-lg">
              {{ teacher.job }}

              <teacher-companies-logos
                :companies="teacher.companies"
                :height="30"
              />
            </p>
          </header>

          <app-text-markdown
            v-if="teacher.description"
            class="prose text-subtle"
            lazy
            :value="teacher.description"
          />

          <app-button
            class="mt-3"
            color="dark"
            size="small"
            :to="{
              name: 'trainers-slug',
              params: { slug: teacher.slug! },
            }"
            variant="tonal"
          >
            {{
              $t("course.page.teacher_details_view_profile_cta", {
                name: teacher.first_name,
              })
            }}
          </app-button>
        </section>
      </figcaption>
    </figure>
  </app-page-subsection>

  <app-page-subsection
    v-if="teacher.testimonials?.length > 0"
    :title="{ tag: 'h3', text: $t('course.page.teacher_testimonials_title') }"
  >
    <teacher-testimonial-list :list="teacher.testimonials" />
  </app-page-subsection>
</template>

<script lang="ts" setup>
const properties = defineProps<{
  teacher: Pick<
    DatabaseTable<"teachers">,
    | "full_name"
    | "avatar_url"
    | "job"
    | "first_name"
    | "testimonials"
    | "slug"
    | "description"
  > & {
    companies: DatabaseTable<"companies">[];
  };
}>();

const { t } = useI18n();

const title = computed(() =>
  t("course.page.teacher_details_title", {
    name: properties.teacher.first_name,
  }),
);
</script>
